import { render, staticRenderFns } from "./QuestionnaireManage.vue?vue&type=template&id=4f9711e6&scoped=true"
import script from "./QuestionnaireManage.vue?vue&type=script&lang=js"
export * from "./QuestionnaireManage.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireManage.vue?vue&type=style&index=0&id=4f9711e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9711e6",
  null
  
)

export default component.exports